
import {useState} from 'react';
import {useNavigate,Link} from 'react-router-dom';
import api from './api/posts';
import Spinner from 'react-bootstrap/Spinner';
import SelectedImages from './SelectedImages'

function NewPost({posts,setPosts,accessToken,setAccessToken}) {
  const [images,setImages]=useState([]);
  const [fromTime, setFromTime] = useState('');
  const [toTime, setToTime] = useState('');
  const [activity, setActivity] = useState('');
  const [outcome, setOutcome] = useState('');
  const [isLoading,setIsloading]=useState(false);

  const navigate=useNavigate();
  function getUID()
  {
     let timestamp=Date.now();
     return timestamp.toString(36);
  }
  const handleAddNew=async (e)=>
  {
     e.preventDefault();
     
     const id=getUID();
     let tdate=new Date();
     const datetime=tdate.toISOString();
     const newPost={
      id,
      //title:postTitle,
      datetime,
      //body:postBody
     };

      let formData = new FormData();    //formdata object

      formData.append("fromTime",fromTime); 
      formData.append("toTime",toTime);

      formData.append("activity", activity);
      formData.append("outcome", outcome);
      Object.values(images).forEach(file=>{
        formData.append("images", file);
      });
      const config = {     
          headers: { 'content-type': 'multipart/form-data' }
      }
      /*const config = {     
          headers: { 'content-type': 'multipart/form-data' }
      }*/

     setIsloading(true);
     try{
      const response= await api.post('/employees',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
        //alert(JSON.stringify(response));
      setIsloading(false);
      navigate('/');
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await api.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          //console.log(`Second at:${accessToken}`);
          try{       
            const response= await api.post('/employees',formData,{headers:{'Authorization':`Bearer ${nat}`}});  
            setIsloading(false);
            navigate('/');
           }
           catch(err)
           {
            alert(JSON.stringify(err));
            alert('unusual error newposts.js');
            setIsloading(false);
            //navigate('/');
           }
        }
        catch(err)
        {
          alert('failed');
          setIsloading(false);
          //setError(JSON.stringify(err));
          //navigate('/');
        }

      }  
    }
 
    function addToImageList(selectedFiles)
    {
      const newImages=[...images,...selectedFiles];
      /*for(let i=0;i<selectedFiles.length;i++)
        {
          let j=0;
          for(j=0;j<images.length;j++)
            {
                if(images[j].name===selectedFiles[i].name)
                  {
                    console.log(selectedFiles[i].name);
                    break;
                  }
            }
          if(j===images.length)
            {
              newImages.push(selectedFiles[i]);
            }        
        }
            */
        setImages(newImages);
        console.log(newImages.length);
    }
    return (
      <main>
        <div className="fullWidth centeredDiv"><h3>Create a New Assesment</h3></div>
        <form className='newPost' onSubmit={handleAddNew}>

        <label className="marginTop" htmlFor='txtFromTime'>From Time:</label>
        <input 
        type='text' className="borderLess"
        id='txtFromTime'
        required
        value={fromTime}
        onChange={(e)=>{setFromTime(e.target.value)}}
        />
        <label className="marginTop" htmlFor='txtToTime'>To Time:</label>
        <input 
        type='text' className="borderLess"
        id='txtToTime'
        required
        value={toTime}
        onChange={(e)=>{setToTime(e.target.value)}}
        />
        <label className="marginTop" htmlFor='txtActivity'>Activity:</label>
        <textarea 
          className="borderLess"
          id='txtActivity'
          required
          value={activity}
          onChange={(e) => setActivity(e.target.value)}
        ></textarea>

        <label className="marginTop" htmlFor='txtOutcome'>Outcome:</label>
        <textarea 
          className="borderLess"
          id='txtOutcome'
          required
          value={outcome}
          onChange={(e) => setOutcome(e.target.value)}
        ></textarea>
        
        <div className='marginTop'>
          <label htmlFor="fuPhotos" className="custom-file-label">
            Select supporting images (if any)
          </label>
          <input
            className="file-input-hidden"
            type="file"
            id="fuPhotos"
            name="uploadedPhotos"
            multiple
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e) => {
              addToImageList(e.target.files);
            }}
          />
      </div>
      <SelectedImages
      images={images}
      setImages={setImages}
      >
      </SelectedImages>


        <div className="secondaryNav marginTop">
            <Link to={`/`}><button className='btn btn-success' style={{fontSize:'13px', letterSpacing:'1.1px'}}>HOME</button></Link>
            <button className='btn btn-primary' style={{fontSize:'13px', letterSpacing:'1.1px'}} type='submit'>SAVE</button>
        </div>
        </form>
        {isLoading && 
        <div className='spinneroverlay'>
          <div className='spinnerbody'>
            <Spinner animation="border" variant="info" />
            <p>Please wait. It might take a few seconds.</p>
          </div>           
        </div>}
      </main>
    )
  }
  
  export default NewPost